export default __webpack_public_path__ + "static/blog-04-900x678-541f08ae691f5fbee8460251b05bc8a6.jpg";